<div>
      <p class="text-[12px] text-gray-400 dark:text-dark-muted">{{ MP.DETAIL_LABEL }}</p>
      <div *ngIf="!editingAlias" class="flex items-center justify-between gap-2">
        <div class="min-w-0 text-[14px] text-gray-700 dark:text-dark-text">
          <span class="font-medium" *ngIf="mpAlias">{{ mpAlias }} · </span>
          <span [class.text-gray-400]="mpAlias" class="break-all">{{ MP.DETAIL_ID }} {{ mpCounterpartyId }}</span>
          <span *ngIf="!mpAlias" class="text-gray-400 dark:text-dark-muted"> · {{ MP.NO_ALIAS }}</span>
        </div>
        <button type="button" (click)="startEditAlias()" [attr.aria-label]="MP.EDIT_ALIAS"
          class="w-9 h-9 rounded-full bg-neutral-soft dark:bg-dark-tertiary flex items-center justify-center text-gray-500 dark:text-dark-muted active:scale-95 transition-transform flex-shrink-0">
          <span class="material-symbols-rounded text-[18px]">edit</span>
        </button>
      </div>
      <div *ngIf="editingAlias" class="flex items-center gap-2 mt-1">
        <input type="text" [(ngModel)]="aliasDraft" [placeholder]="MP.ALIAS_PLACEHOLDER" [attr.aria-label]="MP.ALIAS"
          (keydown.enter)="$event.preventDefault(); saveAlias()" (keydown.escape)="editingAlias = false"
          class="h-12 px-4 rounded-lg border border-neutral-border dark:border-dark-border bg-white dark:bg-dark-secondary text-gray-700 dark:text-dark-text text-sm flex-1 min-w-0">
        <button type="button" (click)="saveAlias()" [disabled]="savingAlias"
          class="h-12 px-4 rounded-full bg-gray-900 dark:bg-white text-white dark:text-gray-900 text-sm font-medium disabled:opacity-50">
          {{ COMMON.SAVE }}
        </button>
        <button type="button" (click)="editingAlias = false" [disabled]="savingAlias" [attr.aria-label]="COMMON.CANCEL"
          class="w-9 h-9 rounded-full flex items-center justify-center text-gray-500 dark:text-dark-muted">
          <span class="material-symbols-rounded text-[18px]">close</span>
        </button>
      </div>
      <p *ngIf="editingAlias" class="text-[12px] text-gray-400 dark:text-dark-muted mt-1">{{ MP.ALIAS_HINT }}</p>
    </div>
